import React from 'react';
import OriginSphere from '../spheres/OriginSphere';
import { Vector3 } from 'three';
import LocationSphere from '../spheres/LocationSphere';
import { Colors } from '../../../data/Colors';
import useAspectScale from '../hooks/useAspectScale';
import DetailedSphere from '../spheres/DetailedSphere';
import FocusPoints from '../../../data/FocusPoints';
import { DetailSectionIDs } from '../../../data/Sections';
import { useDetailViewContext } from '../../../context/DetailViewContext';
import {SceneSection} from '../View3D';

const origin = new Vector3(0, -.9, 0);
const catPos = new Vector3(0.6, 0.1, 0.0);
const carPos = new Vector3(-0.6, 0.1, 0);
const husbandPos = new Vector3(-0.75, 0.1, 0.2);

export default function SphereSubspaces({ groupProps, texts }: SceneSection): JSX.Element
{
  const scale = useAspectScale(1.1);
  const {activeDetailID, activeFocusID} = useDetailViewContext();

  return <group {...groupProps} scale={[ scale, scale, scale ]} visible={activeFocusID === FocusPoints.None || activeDetailID === DetailSectionIDs.DecodingSubspaces}>
    <OriginSphere position={origin}/>

    <LocationSphere label={texts.car} sphereSize={0.5} arrowOrigin={origin} sphereCenter={carPos} azimuth={-2.8} />

    <DetailedSphere label={texts.husband} arrowOrigin={origin} color={Colors.HusbandVector}
      sphereCenter={husbandPos} sphereSize={0.23} arrowAngle={1.8}
      happiness={1.0} winner={1.0} showHappy showWinner
      focusID={FocusPoints.SubspaceHusband}
      texts={texts}
    />

    <DetailedSphere label={texts.cat} arrowOrigin={origin} color={Colors.CatVector}
      sphereCenter={catPos} sphereSize={0.25} arrowAngle={1.8}
      happiness={-1.0} winner={-1.0} showHappy showWinner
      focusID={FocusPoints.SubspaceCat}
      texts={texts}
    />
  </group>;
}
